(() => {
  if (customElements.get('oilogic-moment-video')) return;

/*
 * <oilogic-moment-video> — click-to-unmute UGC video card in the "Real moments"
 * strip. The <video> autoplays muted server-side; the first click on the card
 * enables sound and reveals the control overlay (play/pause + mute). Only one
 * card plays with sound at a time — unmuting a card mutes every other one.
 * State is reflected on the host as data-active / data-playing / data-muted so
 * the CSS can reveal the overlay and swap the button icons.
 */
class OilogicMomentVideo extends HTMLElement {
  #ctrl = new AbortController();

  connectedCallback() {
    this.video = this.querySelector('video');
    this.playBtn = this.querySelector('[data-moment-play]');
    this.muteBtn = this.querySelector('[data-moment-mute]');
    if (!this.video) return;

    const { signal } = this.#ctrl;
    this.addEventListener('click', (event) => this.#onClick(event), { signal });
    this.playBtn?.addEventListener('click', () => this.#togglePlay(), { signal });
    this.muteBtn?.addEventListener('click', () => this.#toggleMute(), { signal });
    this.video.addEventListener('play', () => { this.dataset.playing = ''; }, { signal });
    this.video.addEventListener('pause', () => { this.removeAttribute('data-playing'); }, { signal });
    document.addEventListener('oilogic:moment-video:unmute', (event) => {
      if (event.detail.host !== this) this.#setMuted(true);
    }, { signal });

    if (!this.video.paused) this.dataset.playing = '';
    this.toggleAttribute('data-muted', this.video.muted);
  }

  disconnectedCallback() {
    this.video?.pause();
    this.#ctrl.abort();
  }

  #onClick(event) {
    if (event.target.closest('button')) return;
    if (!this.hasAttribute('data-active')) {
      this.dataset.active = '';
      this.#setMuted(false);
      if (this.video.paused) this.video.play();
      return;
    }
    this.#togglePlay();
  }

  #togglePlay() {
    if (this.video.paused) this.video.play(); else this.video.pause();
  }

  #toggleMute() {
    this.#setMuted(!this.video.muted);
  }

  #setMuted(muted) {
    this.video.muted = muted;
    this.toggleAttribute('data-muted', muted);
    if (!muted) {
      document.dispatchEvent(new CustomEvent('oilogic:moment-video:unmute', { detail: { host: this } }));
    }
  }
}

customElements.define('oilogic-moment-video', OilogicMomentVideo);
})();
